module.exports = __webpack_public_path__ + "img/lianxi-tel.d528be2c.png";